module.exports = __webpack_public_path__ + "static/media/document-icon-grey.ca98f5e9.svg";